import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// INR formatting with Indian grouping (₹1,299 · ₹12,499)
export function inr(n) {
  const num = Number(n || 0);
  return "₹" + num.toLocaleString("en-IN");
}

// Colour swatch hex map for well-known palette names in the catalog
export const COLOUR_HEX = {
  "Cream": "#F1E7D5",
  "Sage": "#97A38A",
  "Terracotta": "#C7683F",
  "Charcoal": "#2B2925",
  "Ruby Red": "#9B1F2C",
  "Marigold": "#E1A22A",
  "Blush": "#EAD3C9",
  "Emerald Green": "#046A38",
  "Magenta Purple": "#8E2A87",
  "Marigold Gold": "#D4A429",
  "Plain White": "#F5F5F0",
  "Royal Blue": "#1E3A8A",
  "Choose colours": "#EAD3C9",
  "Choose sets": "#EAD3C9",
};

export const colorHex = (name) => COLOUR_HEX[name] || "#c9beae";

// WhatsApp: treat the seed placeholder / empty as "not set"
export const WA_PLACEHOLDER = "919999999999";
export function waNumber(n) {
  const d = (n || "").replace(/\D/g, "");
  if (!d) return "";
  if (d === WA_PLACEHOLDER || d === "9999999999") return "";
  return d;
}
export const waEnabled = (n) => !!waNumber(n);

// Placeholder rule: any value containing "[" is unconfirmed — never render it.
export const hasPlaceholder = (s) => typeof s === "string" && s.includes("[");
export const cleanText = (s) => (hasPlaceholder(s) ? "" : (s || ""));
export function perPieceText(price, pieces) {
  if (!pieces || pieces <= 1) return "";
  const each = Math.round(price / pieces);
  return `₹${Number(price).toLocaleString("en-IN")} for ${pieces} · ₹${each} each`;
}

// Studio address placeholder check
export const isPlaceholderAddress = (a) =>
  !a || /^\s*Little Oak Studio, Pune, Maharashtra 411001\s*$/i.test(a);

// Category → simple category slug for placeholder art
export const catSlug = (c = "") => {
  const k = c.toLowerCase();
  if (k.includes("candle")) return "candle";
  if (k.includes("tealight")) return "tealight";
  if (k.includes("planter")) return "planter";
  if (k.includes("idol") || k.includes("wall")) return "idol";
  if (k.includes("keychain")) return "keychain";
  if (k.includes("gift")) return "gift";
  if (k.includes("party")) return "mini";
  return "candle";
};

export const budgetLabel = (v) =>
  ({ under_499: "Under ₹499", "500_999": "₹500–₹999", "1000_1999": "₹1,000–₹1,999", "2000_plus": "₹2,000+" }[v] || v);

// analytics
let sessionId = null;
export function getSessionId() {
  if (sessionId) return sessionId;
  let s = localStorage.getItem("lo_sid");
  if (!s) {
    s = (crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2));
    localStorage.setItem("lo_sid", s);
  }
  sessionId = s;
  return s;
}

export function getUTM() {
  try {
    const stored = JSON.parse(localStorage.getItem("lo_utm") || "null");
    if (stored) return stored;
  } catch (_) {}
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  if (!utm.utm_source && document.referrer) {
    try { utm.utm_source = new URL(document.referrer).hostname; utm.utm_medium = "referral"; } catch (_) {}
  }
  localStorage.setItem("lo_utm", JSON.stringify(utm));
  return utm;
}

export const device = () => (window.innerWidth < 640 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop");
